<template>
  <div class="clubs-page" :class="{ 'clubs-page--en': !isAr }">
    <section class="heroSection">
      <b-container fluid>
        <b-row class="intro-section clubs-intro-row justify-content-around">
          <b-col
            xl="12"
            lg="12"
            md="12"
            class="clubs-hero-col d-flex align-items-center justify-content-center text-center"
          >
            <div class="text-section">
              <div>
                <h1 class="mb-3 clubs-hero-title"><b>{{ langDec.clubs_page_hero_title }}</b></h1>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="message">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col
            xl="12"
            lg="12"
            md="12"
            class="clubs-message-col d-flex align-items-center justify-content-center"
          >
            <div class="text-section clubs-message-panel">
              <div class="clubs-message-inner">
                <span class="clubs-intro-kicker d-inline-block">{{ langDec.clubs_page_intro_kicker }}</span>
                <h2 class="mt-2 clubs-intro-heading"><b>{{ langDec.clubs_page_intro_title }}</b></h2>
                <p class="clubs-intro-body">{{ langDec.clubs_page_intro_body }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="clubsSection">
      <b-container>
        <div class="clubs-loading text-muted my-4" v-if="pageIsLoading">
          <b-spinner class="align-middle clubs-loading__spin" />
          <span class="clubs-loading__text">{{ langDec.clubs_loading }}</span>
        </div>
        <p v-else-if="loadError" class="text-center text-danger my-4">{{ langDec.clubs_load_error }}</p>
        <p v-else-if="items.length === 0" class="text-center text-muted my-4">{{ langDec.clubs_empty }}</p>
        <div v-for="item in items" :key="item.id" class="py-5 clubs-card-block">
          <b-row class="align-items-center">
            <b-col xl="6" lg="12" md="12" class="clubs-card-copy-col">
              <div class="w-100 clubs-card-copy">
                <h3 class="mb-3 clubs-card-title"><b>{{ item.title }}</b></h3>
                <div class="clubs-card-meta">
                  <span>{{ item.followersCount }} {{ langDec.clubs_followers_label }}</span>
                  <span class="clubs-meta-sep">{{ isAr ? ' ، ' : ', ' }}</span>
                  <span>{{ item.postsCount }} {{ langDec.clubs_posts_label }}</span>
                </div>
                <p class="clubs-card-desc">{{ clubDescriptionPlain(item) }}</p>
              </div>
            </b-col>
            <b-col xl="6" lg="12" md="12" class="clubs-card-media-col">
              <div class="clubs-card-media">
                <img
                  class="clubs-card-img"
                  width="90%"
                  :src="'https://api.takhatty.com/' + item.imageUrl"
                  :alt="item.title || langDec.clubs_page_hero_title"
                >
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>

    <section class="subscribe">
      <div class="clubs-subscribe-inner col-md-12 py-5 my-5 text-center">
        <h2 class="clubs-subscribe-heading px-3">{{ langDec.clubs_subscribe_heading }}</h2>
        <div class="description">
          <p
            v-if="!googleplay && !applestore"
            class="clubs-app-unavailable mt-3 px-3"
          >
            <b>{{ langDec.experts_page_app_unavailable }}</b>
          </p>
          <b-button
            v-if="!googleplay && !applestore"
            class="px-4 py-2 my-4"
            variant="primary"
            @click="goToRoute('contactus')"
          >
            {{ langDec.nav_contact }}
          </b-button>
        </div>
        <div v-if="googleplay || applestore" class="action-btns mt-4">
          <b-button
            v-if="applestore"
            class="clubs-store-btn clubs-store-btn--apple px-4 py-3 mx-3 my-3"
            @click="goTowebsite(applestore)"
          >
            <div
              class="clubs-store-badge-inner px-3"
              :class="{ 'clubs-store-badge-inner--en': !isAr }"
            >
              <div class="clubs-store-badge-inner__icon clubs-store-badge-inner__icon--apple">
                <img
                  class="clubs-store-badge-inner__apple-img"
                  src="../assets/images/Apple_logo_white.svg.png"
                  alt=""
                >
              </div>
              <div class="clubs-store-badge-inner__text clubs-store-text">
                <span>{{ langDec.nav_available_on }}</span>
                <br>
                <span>App Store</span>
              </div>
            </div>
          </b-button>
          <b-button
            v-if="googleplay"
            class="clubs-store-btn clubs-store-btn--google px-4 py-3 mx-3 my-3"
            variant="primary"
            @click="goTowebsite(googleplay)"
          >
            <div
              class="clubs-store-badge-inner px-3"
              :class="{ 'clubs-store-badge-inner--en': !isAr }"
            >
              <div class="clubs-store-badge-inner__icon clubs-store-badge-inner__icon--google">
                <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" d="M0,0h40v40H0V0z" />
                  <g>
                    <path
                      d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                      fill="#EA4335"
                    />
                    <path
                      d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                      fill="#FBBC04"
                    />
                    <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4" />
                    <path
                      d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                      fill="#34A853"
                    />
                  </g>
                </svg>
              </div>
              <div class="clubs-store-badge-inner__text clubs-store-text">
                <span>{{ langDec.nav_available_on }}</span>
                <br>
                <span>Google Play</span>
              </div>
            </div>
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { sendRequest } from "../utils/RequestHelper.js";

export default {
  name: "Clubs",
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      items: [],
      pageIsLoading: false,
      loadError: false,
    };
  },
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {};
    },
    currentLang() {
      return this.getlang || "ar";
    },
    isAr() {
      return this.currentLang === "ar";
    },
  },
  methods: {
    /** API may return HTML strings; mustache binding escapes tags so they show literally */
    clubDescriptionPlain(item) {
      const raw = item?.description ?? item?.shortDescription ?? "";
      if (raw == null || typeof raw !== "string") return "";
      return raw.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    },
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToRoute(name) {
      this.$router.push({ name }).catch(() => {});
    },
    loadData() {
      this.pageIsLoading = true;
      this.loadError = false;
      const body = {
        pageNumber: 1,
        pageSize: 20,
      };
      sendRequest(
        "post",
        "club/search",
        true,
        body,
        (response) => {
          const raw = response?.data?.data?.items;
          this.items = Array.isArray(raw) ? raw : [];
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
          this.loadError = true;
          this.items = [];
        }
      );
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
.heroSection .intro-section.clubs-intro-row {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../assets/images/club.png);
  background-size: cover;
  background-position: bottom center;
  width: auto;
  height: 350px !important;
  color: white;
}

.heroSection .text-section {
  display: flex;
  align-items: center;
}

.heroSection .clubs-hero-title,
.heroSection .text-section h2 {
  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}

.message {
  padding: 80px 20px;
}

.message .text-section.clubs-message-panel {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 20px;
  width: 65%;
}

.clubs-message-inner {
  width: 100%;
  text-align: start;
}

.clubs-intro-kicker {
  color: #006633;
  font-size: 16px;
}

.clubs-intro-heading {
  font-size: 32px;
  margin-top: 8px;
  margin-bottom: 30px;
  font-weight: bold;
}

.clubs-intro-body {
  margin-bottom: 0;
  line-height: 1.7;
}

.clubs-message-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clubs-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.clubsSection {
  background-image: url("../assets/images/orangeWhiteBG.png");
  background-position: center center;
  background-size: cover;
}

.clubs-card-copy-col,
.clubs-card-media-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clubs-card-copy {
  text-align: start;
}

.clubs-card-title {
  font-size: 1.35rem;
}

.clubs-card-meta {
  color: #6c757d;
  font-size: 12px;
}

.clubs-card-desc {
  margin-top: 15px;
  margin-bottom: 0;
}

.clubs-card-media {
  text-align: center;
  width: 100%;
}

.clubs-card-img {
  max-width: 100%;
  height: auto;
}

.subscribe {
  background-color: #f5f5f5;
}

.clubs-subscribe-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.clubs-subscribe-heading {
  max-width: 44rem;
  margin-inline: auto;
}

.clubs-app-unavailable {
  color: #c0392b;
}

.clubs-store-btn {
  color: #fff !important;
}

.clubs-store-btn--apple {
  background-color: #000 !important;
  border-color: #000 !important;
}

.clubs-store-btn--google {
  border-color: #000 !important;
}

.clubs-store-text {
  font-size: 14px;
}

.clubs-store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.clubs-store-badge-inner--en {
  flex-direction: row-reverse;
}

.clubs-store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clubs-store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.clubs-store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.clubs-store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.clubs-store-badge-inner__text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}

@media (max-width: 991.98px) {
  .intro-section.clubs-intro-row {
    height: 550px !important;
  }

  .heroSection .clubs-hero-title,
  .text-section h2 {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .message .text-section.clubs-message-panel {
    padding: 10px;
    width: 80%;
  }
}

@media (max-width: 767.98px) {
  .intro-section.clubs-intro-row {
    height: 350px !important;
  }

  .message .text-section.clubs-message-panel {
    width: 95%;
  }
}
</style>
